import Vue from "vue";
import Router from "vue-router";
import routes from "./routes/standard-routing";
import employeeRoutes from "./routes/employee-routing";
import remingtonSeedsRoutes from "./routes/remington-seeds-routing";
import priRoutes from "./routes/pri-routing";
import thirdpartyRoutes from "./routes/thirdparty-routing";
import remdiationRoutes from "./routes/remdiation-routing";
import commonRoutes from "./routes/common-routes";
import store from "./store.js";

Vue.use( Router );
let allRoutes = [];
switch ( process.env.VUE_APP_APPLICATION ) {
  case "employee":
    allRoutes = [...employeeRoutes, ...commonRoutes];
    break;
  case "remington_seeds":
    allRoutes = [...remingtonSeedsRoutes];
    break;
  case "pri":
    allRoutes = [...priRoutes, ...commonRoutes];
    break;
  case "thirdparty":
    allRoutes = [...thirdpartyRoutes, ...commonRoutes];
    break;
  case "remdiation":
    allRoutes = [...remdiationRoutes, ...commonRoutes];
    break;
  default:
    allRoutes = [...routes, ...commonRoutes];
}

let userGroupId = localStorage.getItem( "userGroupId" );

const router = new Router( {
  mode: "history",
  base: process.env.VUE_APP_ENVIRONMENT === "production" ? "/onboarding/" : "/",
  routes: allRoutes,
} );

router.beforeEach( ( to, from, next ) => {
  // this condition works for employee application and remington seeds application as we are not storing access tokken in localStorage we are authentication user with JID cookiee
  if ( process.env.VUE_APP_APPLICATION == "employee" || process.env.VUE_APP_APPLICATION == "remington_seeds" ) {
    // store.getters.accessToken only lives in memory for the current SPA
    // session — several login redirects (window.location.href) do a hard
    // reload, which wipes it even though localStorage still has a valid
    // token. Fall back to localStorage here, same as the "pri" guard below.
    let employeeAccessToken = store.getters.accessToken || localStorage.getItem( "accessToken" );
    if ( to.name !== "login" && to.meta.jwtRequiresAuth ) {
      if ( employeeAccessToken ) {
        next();
      } else {
        router.replace( "/" );
      }
    } else if ( to.name == "login" && employeeAccessToken ) {
      let userType = localStorage.getItem( "userType" );
      if ( userType == 3 || userType == 2 ) {
        router.replace( "/dashboard" );
      } else {
        if(process.env.VUE_APP_APPLICATION == "remington_seeds" ){
          router.replace( "/goverance/one" );
        }else{
          router.replace( "/manage-employee" );
        }
      }
    } else {
      next();
    }
  }
  if ( process.env.VUE_APP_APPLICATION == "pri" ) {
    let accessToken = localStorage.getItem( "accessToken" ); // temp enable for functionality
    if ( to.path !== "/login" && to.meta.requiresAuth ) {
      if ( store.getters.accessToken || accessToken ) {
        next();
      } else {
        router.replace( "/login" );
      }
    } else {
      next();
    }
  } else {
    let accessToken = localStorage.getItem( "accessToken" );
    if ( to.path !== "/login" && to.meta.requiresAuth == true ) {
      if ( accessToken ) {
        next();
      } else {
        router.replace( "/login" );
      }
    } else {
      next();
    }
  }

  //  next()
} );

export default router;
